'use client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { WISHLIST_QUERIES } from '../../infrastructure/wishlist/utils/queries';
import type { GetWishlistRequest } from '../../infrastructure/wishlist/utils/types';
import { useWishlistCustomerKey } from '../../context';

export const useWishlistService = () => {
  const useGetWishlist = (payload: GetWishlistRequest) => {
    const { setCustomerKey } = useWishlistCustomerKey();
    const query = useQuery(WISHLIST_QUERIES.getWishlist(payload));

    useEffect(() => {
      if (query.data?.customerKey) {
        setCustomerKey(query.data.customerKey);
      }
    }, [query.data?.customerKey, setCustomerKey]);

    return query;
  };

  const useAddProductToWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.addProductToWishlist(queryClient));
  };

  const useRemoveProductFromWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.removeProductFromWishlist(queryClient));
  };

  return {
    useAddProductToWishlist,
    useRemoveProductFromWishlist,
    useGetWishlist,
  };
};
